type ExternalChromeRuntime = {
  sendMessage: (
    extensionId: string,
    message: { type: string },
    callback?: (response?: { ok?: boolean }) => void
  ) => void
  lastError?: unknown
}

export const notifyExtension = (
  extensionId: string | null,
  type: "EXTENSION_CHECKOUT_COMPLETED" | "EXTENSION_ACCOUNT_UPDATED"
) =>
  new Promise<boolean>(resolve => {
    if (!extensionId || !/^[a-p]{32}$/.test(extensionId)) {
      resolve(false)
      return
    }
    const runtime = (
      window as typeof window & { chrome?: { runtime?: ExternalChromeRuntime } }
    ).chrome?.runtime
    if (!runtime) {
      resolve(false)
      return
    }
    const timeout = window.setTimeout(() => resolve(false), 1500)
    try {
      runtime.sendMessage(extensionId, { type }, response => {
        void runtime.lastError
        window.clearTimeout(timeout)
        resolve(response?.ok === true)
      })
    } catch {
      window.clearTimeout(timeout)
      resolve(false)
    }
  })
